import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex justify-center m-2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CardWithTitle = _resolveComponent("CardWithTitle")!

  return (_ctx.inquiryCode)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_CardWithTitle, {
          title: "ユーザーID",
          class: "sm:w-6/12 text-center text-gray-700"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.inquiryCode), 1)
          ]),
          _: 1
        })
      ]))
    : _createCommentVNode("", true)
}